import { BatteryMode, PowerSource } from '../tags.types';
import {
  BATTERY_MODES,
  BATTERY_MODE_LABEL_MAP,
  POWER_SOURCES,
  POWER_SOURCE_ICON_MAP,
  POWER_SOURCE_LABEL_MAP,
} from '../tags.utils';
import { TagInputConfig } from './TagInput.types';

export const powerSourceConfig: TagInputConfig<PowerSource> = {
  labelMapping: POWER_SOURCE_LABEL_MAP,
  iconMapping: POWER_SOURCE_ICON_MAP,
  options: POWER_SOURCES,
  defaultValue: [],
};

export const batteryModeConfig: TagInputConfig<BatteryMode> = {
  labelMapping: BATTERY_MODE_LABEL_MAP,
  options: BATTERY_MODES,
  defaultValue: [],
};
